function loadDepartmentTree(pageObj, dataProp, stateProp, callback) {
    if (dataProp) {
        eval('pageObj.' + dataProp + ' = []');
    }
    if (stateProp) {
        eval('pageObj.' + stateProp + ' = true');
    }
    window.ax.get('api/system/department?sign=' + window.$gloable.userinfo.sign).then(rsp => {
        let data = rsp.data;
        if (data.code == 1) {
            data = data.data;
            if (dataProp) {
                eval('pageObj.' + dataProp + ' = data');
            }
            if (callback) {
                callback(data);
            }
        } else {
            pageObj.$message.error(data.message);
        }
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    }).catch(err => {
        pageObj.$message.error('执行脚本出错，请联系管理员');
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    });
}
function loadAuthorizeGroup(pageObj, dataProp, stateProp, type, callback) {
    if (dataProp) {
        eval('pageObj.' + dataProp + ' = []');
    }
    if (stateProp) {
        eval('pageObj.' + stateProp + ' = true');
    }
    window.ax.get('api/device/group/displaylist?sign=' + window.$gloable.userinfo.sign + '&id=' + type).then(rsp => {
        let data = rsp.data;
        if (data.code == 1) {
            data = data.data;
            if (dataProp) {
                eval('pageObj.' + dataProp + ' = data');
            }
            if (callback) {
                callback(data);
            }
        } else {
            pageObj.$message.error(data.message);
        }
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    }).catch(err => {
        pageObj.$message.error('执行脚本出错，请联系管理员');
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    });
}
function loadAuthorizeDoor(pageObj, dataProp, stateProp, callback) {
    if (dataProp) {
        eval('pageObj.' + dataProp + ' = []');
    }
    if (stateProp) {
        eval('pageObj.' + stateProp + ' = true');
    }
    window.ax.get('api/device/door/displaylist?sign=' + window.$gloable.userinfo.sign).then(rsp => {
        let data = rsp.data;
        if (data.code == 1) {
            data = data.data;
            if (dataProp) {
                eval('pageObj.' + dataProp + ' = data');
            }
            if (callback) {
                callback(data);
            }
        } else {
            pageObj.$message.error(data.message);
        }
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    }).catch(err => {
        pageObj.$message.error('执行脚本出错，请联系管理员');
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    });
}
function loadVehAuthorizeGroup(pageObj, dataProp, stateProp, type, callback) {
    if (dataProp) {
        eval('pageObj.' + dataProp + ' = []');
    }
    if (stateProp) {
        eval('pageObj.' + stateProp + ' = true');
    }
    window.ax.get('api/device/group/vehiclelist?sign=' + window.$gloable.userinfo.sign + '&id=' + type).then(rsp => {
        let data = rsp.data;
        if (data.code == 1) {
            data = data.data;
            if (dataProp) {
                eval('pageObj.' + dataProp + ' = data');
            }
            if (callback) {
                callback(data);
            }
        } else {
            pageObj.$message.error(data.message);
        }
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    }).catch(err => {
        pageObj.$message.error('执行脚本出错，请联系管理员');
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    });
}
function loadAreasTree(pageObj, dataProp, stateProp, callback) {
    if (dataProp) {
        eval('pageObj.' + dataProp + ' = []');
    }
    if (stateProp) {
        eval('pageObj.' + stateProp + ' = true');
    }
    window.ax.get('api/device/area/tree?sign=' + window.$gloable.userinfo.sign).then(rsp => {
        let data = rsp.data;
        if (data.code == 1) {
            data = data.data;
            if (dataProp) {
                eval('pageObj.' + dataProp + ' = data');
            }
            if (callback) {
                callback(data);
            }
        } else {
            pageObj.$message.error(data.message);
        }
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    }).catch(err => {
        pageObj.$message.error('执行脚本出错，请联系管理员');
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    });
}
function loadEmpHandleSetting(pageObj, dataProp, stateProp, callback) {
    if (dataProp) {
        eval('pageObj.' + dataProp + ' = {}');
    }
    if (stateProp) {
        eval('pageObj.' + stateProp + ' = true');
    }
    window.ax.get('api/rehandle/employee/settinginfo?sign=' + window.$gloable.userinfo.sign).then(rsp => {
        let data = rsp.data;
        if (data.code == 1) {
            data = data.data;
            if (dataProp) {
                eval('pageObj.' + dataProp + ' = data');
            }
            if (callback) {
                callback(data);
            }
        } else {
            pageObj.$message.error(data.message);
        }
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    }).catch(err => {
        pageObj.$message.error('执行脚本出错，请联系管理员');
        if (stateProp) {
            eval('pageObj.' + stateProp + ' = false');
        }
    });
}

export default {
    loadDepartmentTree,
	loadAuthorizeGroup,
	loadAuthorizeDoor,
	loadVehAuthorizeGroup,
	loadAreasTree,
	loadEmpHandleSetting
}
